export default "__VITE_ASSET__VUjNkhDO__"